import { useState } from "react";
import { Play, VideoOff } from "lucide-react";
import { API } from "@/lib/api";
import StreamVideo, { hasTrailer } from "@/components/StreamVideo";

// Admin review: poster cover that swaps to the trailer player on tap.
export default function TrailerPreview({ film, posterSrc, className = "", children }) {
  const [playing, setPlaying] = useState(false);
  const available = hasTrailer(film);
  const legacySrc = film.trailer_path
    ? `${API}/films/${film.id}/trailer${film.trailer_uploaded_at ? `?v=${encodeURIComponent(film.trailer_uploaded_at)}` : ""}`
    : null;

  return (
    <div className={`relative aspect-video bg-ink overflow-hidden ${className}`} data-testid={`trailer-preview-${film.id}`}>
      {playing ? (
        <StreamVideo
          playbackPath={`/films/${film.id}/trailer-playback`}
          legacySrc={legacySrc}
          controls
          autoPlay
          playsInline
          controlsList="nodownload"
          className="w-full h-full bg-black"
          data-testid={`trailer-player-${film.id}`}
        />
      ) : (
        <>
          <img src={posterSrc} alt="" className="w-full h-full object-cover opacity-70" onError={(e) => { e.currentTarget.style.opacity = 0; }} />
          {available ? (
            <button
              type="button"
              onClick={() => setPlaying(true)}
              className="absolute inset-0 m-auto w-fit h-fit inline-flex items-center gap-2 px-4 py-2 rounded-full bg-black/70 backdrop-blur border border-white/20 text-white text-sm font-semibold hover:bg-terracotta transition-colors"
              data-testid={`play-trailer-${film.id}`}
            >
              <Play className="w-4 h-4 fill-white" /> Play trailer
            </button>
          ) : (
            <span className="absolute top-3 left-3 inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-black/70 text-white/70 text-[11px]" data-testid={`no-trailer-${film.id}`}>
              <VideoOff className="w-3.5 h-3.5" /> No trailer
            </span>
          )}
          {children}
        </>
      )}
    </div>
  );
}
